import { authFetch } from "../helpers/FetchHelpers";
const { default: DataService } = require("./DataService");

class SettingDataService extends DataService {
    constructor() {
        super("settings")
    }

    getList() {
        return authFetch(process.env.REACT_APP_API_URL + '/settings/list', 'POST', JSON.stringify({}));
    }
}

export default SettingDataService;
